import GlobalClasses from "styles/global"
import React from "react"
import { createUseStyles } from "react-jss"

const useStyles = createUseStyles(theme => {
  return {
    ...GlobalClasses,

    container: {
      position: "relative",
      display: "flex",
      justifyContent: "center",

      "&-label": {
        display: "none",
        position: "absolute",
        zIndex: "100",
        bottom: "calc(100% + 10px)",

        padding: "5px 11px",
        fontSize: "8px",
        fontWeight: "700",
        letterSpacing: "0.33px",
        textTransform: "uppercase",

        "&-arrow": {
          position: "absolute",
          top: "100%",
        },
      },

      "&:hover &-label": {
        display: "flex",
        justifyContent: "center",
      },
    },

    colorItem: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "32px",
      height: "32px",
      border: "2px solid none",
      borderRadius: "5px",
      padding: "0px",
      margin: "0px",

      "&:hover": {
        cursor: "pointer",
      },

      "&--selected": {
        border: `2px solid ${theme.colors.primaryGreen}`,
      },

      "&-color": {
        display: "block",
        width: "24px",
        height: "24px",
        boxShadow:
          "1px 1px 3px rgba(166, 171, 189, 0.6), -1px -1px 3px #ffffff",
        borderRadius: "3px",
        backgroundImage:
          "linear-gradient(-42deg, rgba(0, 0, 0, .2) 0%, rgba(0, 0, 0, 0) 100%)",
      },
    },

    secondaryColorItem: {
      width: "50%",
      marginLeft: "50%",
      height: "100%",
      borderRadius: "0 3px 3px 0",
      backgroundImage:
        "linear-gradient(-42deg, rgba(0, 0, 0, .2) 0%, rgba(0, 0, 0, 0) 100%)",
    },
  }
})

type Props = {
  selected?: boolean
  label?: string
  hex: string
  onClick?: () => void
  clickable?: boolean
  width?: number
  height?: number
}

const ColorItem: React.FC<Props> = (props: Props) => {
  const classes = useStyles()

  let hex1;
  let hex2;
  if (props.hex) {
    [hex1, hex2] = props.hex.split("/")
  }

  const itemStyle = {}
  if (!props.clickable) {
    itemStyle["pointerEvents"] = "none"
  }
  if (props.width) {
    itemStyle["width"] = props.width + 6
  }
  if (props.height) {
    itemStyle["height"] = props.height + 6
  }

  const colorStyle = {}
  if (props.width) {
    colorStyle["width"] = props.width
  }
  if (props.height) {
    colorStyle["height"] = props.height
  }

  return (
    <span className={`${classes.container}`}>
      <span
        className={`${classes.colorItem} ${
          props.selected ? `${classes.colorItem}--selected` : ""
        }`}
        onClick={props.onClick}
        style={itemStyle}
      >
        <div
          className={`${classes.colorItem}-color`}
          style={{ ...colorStyle, backgroundColor: `${hex1}` }}
        >
          {hex2?.length ? (
            <div
              className={`${classes.secondaryColorItem}`}
              style={{ backgroundColor: `${hex2}` }}
            />
          ) : null}
        </div>
      </span>
      {props.label?.length && (
        <div className={`${classes.hintBox} ${classes.container}-label`}>
          <div
            className={`${classes.hintBox}-arrow ${classes.hintBox}-arrow--bottom ${classes.container}-label ${classes.container}-label-arrow`}
          />
          {props.label}
        </div>
      )}
    </span>
  )
}

ColorItem.defaultProps = {}

export default ColorItem
